import { FC, useEffect, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { Row, Col} from "antd";
import "./overview.scss";

// import CurrentHealthStats from "./current-health-stats";
import Vitals from "./vitals";
import Labs from "./labs";
import KeyNumbers from "./key-numbers";
import EndOfLife from "./end-of-life";
import Icon from "@assets/icon_config";
import membersService from "@services/members.service";

import PatientProfileMatrix from "./patient-profile-matrix";
import MemberDetails from "./memberDetails/memberDetails";
import { centricClientCheck } from "@utils/helpers";

const Overview: FC<any> = (props) => {

  
  const defaultExpandedCards = ["37"];
  const expandAllCards = ["37", "34", "36", "3"];
  const patientId = membersService?.getCurrentMember?.patient_id;
  const isCentric = centricClientCheck()

  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);

  useEffect(() => {
    console.log("Overview.useEffect");
    appInsights.trackPageView({name:"Profile"});
  },[]);

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
  },[patientId])

  const changeCollapse = () => {
    if(activePanels?.length > 0) {
      setActivePanels([])
    } else {
      setActivePanels(expandAllCards)
    }
  }

  return (
    <>
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"}{" "}</span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>
      <Row>
        <Col span={24}>
          <MemberDetails pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels}/>
        </Col>
      </Row>
      {!isCentric && (
        <>
          <Row style={{ marginTop: 8 }}>
            <Col span={24}>
              <EndOfLife pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />
            </Col>
          </Row>
          <Row style={{ marginTop: 8 }}>
            <Col span={24}>
              <PatientProfileMatrix pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} />
            </Col>
          </Row>
        </>
      )}
      <Row style={{ marginTop: 8 }}>
        <Col span={24}>
          <KeyNumbers pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels}/>
        </Col>
      </Row>
      {/* 
      <Row>
        <Col span={24}>
          <CurrentHealthStats data={props?.data} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={["1"]} />
        </Col>
      </Row>
       */}
      {/* {
        process.env.REACT_APP_SHOW_LABS_VITALS === 'true' &&
        <>
      <Row style={{ marginTop: 8 }}>
        <Col span={24}>
          <Vitals pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={["1"]} />
        </Col>
      </Row>
      <Row style={{ marginTop: 8 }}>
        <Col span={24}>
          <Labs pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={["1"]} />
        </Col>
      </Row>
      </>
      } */}
    </>
  );
};

export default withAITracking(reactPlugin, Overview);
